import React from 'react';
import { Quotes as QuotesComponent } from '@thd-olt-component-react/quotes';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { string } from 'prop-types';
import { ImpressionProvider } from '@thd-olt-component-react/impression';

export function Quotes({ id }) {

  const data = {
    name: 'Quotes',
    component: 'Quotes',
    type: 'content',
    position: '',
    id
  };

  return (
    <ErrorBoundary name="quotes">
      <QueryProvider cacheKey="quotes-cacheKey">
        <ImpressionProvider data={data}>
          <QuotesComponent componentId={id} />
        </ImpressionProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}

Quotes.propTypes = {
  id: string.isRequired,
};
